import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=7043e9b1&"
import script from "./TopNavbar.vue?vue&type=script&lang=js&"
export * from "./TopNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseDropdown: require('/nvme_data/andreas/git/pcbarts/lenti/lenti_api/master/frontend/components/BaseDropdown.vue').default})
